/**
 * #4449 — a testing-station PC opens on its station view after sign-in.
 *
 * The station is a setting of the DEVICE, not the person: it lives in this
 * browser's localStorage only, never in the user's settings or on the server,
 * so the same technician still lands normally on a phone or an office PC.
 * Every storage touch is wrapped: blocked storage just means "no station".
 */
import { isPathAllowed } from "@shared/rbac";

export const STATION_HOME_KEY = "crosbe-station-home";

/** Below this width a device is a phone, and a phone is never a station (matches HomeRoute). */
export const STATION_MIN_WIDTH = 640;

// Station screens: which sets each shows. Flexurals ride the compressions
// station (same press, per Gus's lab layout).
export const STATIONS: Record<string, { title: string; sets: string[] }> = {
  compressions: { title: "Compressions", sets: ["compressions", "flexurals"] },
  shrinkages: { title: "Shrinkages", sets: ["shrinkages"] },
};

export function isStationKey(key: string | null | undefined): key is string {
  return !!key && Object.prototype.hasOwnProperty.call(STATIONS, key);
}

export function readStationHome(): string | null {
  try {
    const v = localStorage.getItem(STATION_HOME_KEY);
    return isStationKey(v) ? v : null;
  } catch {
    return null;
  }
}

export function writeStationHome(key: string | null): void {
  try {
    if (key && isStationKey(key)) localStorage.setItem(STATION_HOME_KEY, key);
    else localStorage.removeItem(STATION_HOME_KEY);
  } catch {
    // blocked storage: nothing to remember, nothing to clear
  }
}

/**
 * Where `/` should send this device, or null to land as today. Fail-closed:
 * unknown pages (null) never redirect.
 */
export function stationLanding(pages: string[] | null, viewportWidth: number, saved: string | null = readStationHome()): string | null {
  if (!pages || !isStationKey(saved)) return null;
  if (viewportWidth < STATION_MIN_WIDTH) return null;
  if (!isPathAllowed("/reminders", pages)) return null;
  return `/reminders?station=${saved}`;
}
